export const locales = ["fa", "en", "ar"] as const;
export type Locale = (typeof locales)[number];

export const DEFAULT_LOCALE: Locale = "fa";
export const LOCALE_COOKIE = "locale";

export function getDirection(locale: Locale): "rtl" | "ltr" {
  return locale === "en" ? "ltr" : "rtl";
}

/**
 * A DB-sourced localized name object, stored as JSONB `{ fa, en, ar }` on the
 * backend (categories, brands, colors, delivery methods, vendor categories,
 * airports). The generated API types only declare `fa`/`en`, but the API
 * returns the raw column, so `ar` is present at runtime — hence it is optional
 * here and read defensively.
 */
export type LocalizedName = {
  fa?: string | null;
  en?: string | null;
  ar?: string | null;
};

/**
 * Resolve a localized name object for the active locale, falling back to
 * English then Persian (then empty string). Use this everywhere a JSONB
 * `name`/`city` object is rendered, instead of hardcoding `name.fa`.
 */
export function localizeName(
  name: LocalizedName | null | undefined,
  locale: string,
): string {
  if (!name) return "";
  const value = (name as Record<string, string | null | undefined>)[locale];
  return value || name.en || name.fa || "";
}
